<template>
    <div class="page-container">
        <!-- Animated Background -->
        <AnimatedBackground />

        <!-- About Hero Section -->
        <AboutHeroSection />

        <!-- Contact Section -->
        <ContactSection />

        <!-- Legal Links Section -->
        <LegalLinksSection />

        <!-- Footer Section -->
        <FooterSection />
    </div>
</template>

<script>
import AnimatedBackground from '@/components/AnimatedBackground.vue';
import AboutHeroSection from '@/components/about/AboutHeroSection.vue';
import ContactSection from '@/components/about/ContactSection.vue';
import LegalLinksSection from '@/components/about/LegalLinksSection.vue';
import FooterSection from '@/components/home/FooterSection.vue';

export default {
    name: 'AboutView',
    components: {
        AnimatedBackground,
        AboutHeroSection,
        ContactSection,
        LegalLinksSection,
        FooterSection
    },
    mounted() {
        this.setupFadeInObserver();
    },
    methods: {
        setupFadeInObserver() {
            const fadeInObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('is-visible');
                        }
                    });
                },
                {
                    threshold: 0.2,
                    rootMargin: '0px 0px -50px 0px'
                }
            );

            // Observe all fade-in sections
            const fadeElements = document.querySelectorAll('.fade-in-section, .stagger-children');
            fadeElements.forEach((el) => fadeInObserver.observe(el));
        }
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Crimson+Pro:wght@400;500&display=swap');

* {
    font-family: "Space Grotesk", sans-serif;
    font-weight: 400;
    letter-spacing: 1px;
    box-sizing: border-box;
}

.page-container {
    position: relative;
    overflow-x: hidden;
    min-height: 100vh;
    background: var(--bg-primary);
}

/* Scrollbar */
::-webkit-scrollbar {
    width: 12px;
}

::-webkit-scrollbar-track {
    background: var(--bg-primary);
}

::-webkit-scrollbar-thumb {
    background: var(--accent);
    border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
    background: #ffd98e;
}
</style>
